import { useParams } from 'react-router';

import { ProcessingScreenWithStore } from './ProcessingScreen';
import { UploadScreenWithStore } from './UploadScreen';

export default function BatchGeneration() {
  const { id: processId } = useParams<{ id: string }>();

  if (processId) {
    return (
      <div className="flex w-full flex-col">
        <ProcessingScreenWithStore />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col">
      <UploadScreenWithStore />
    </div>
  );
}
